import {
    DestroyRef,
    Inject,
    Injectable,
    PLATFORM_ID,
    WritableSignal,
    inject,
    signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    ForgetPasswordRequest,
    LoginRequest,
    SendActivationCodeRequest,
    VerifyActivationCodeRequest,
} from '@core/models/DTOs/authentication.dto';
import { GetUserProfileResponse } from '@core/models/DTOs/userProfile.dto';
import { AuthRepository } from '@repos/auth.repository';
import { UserProfileRepository } from '../repositories/userProfile.repository';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { WebengageService } from '../webengage.service';
import { CacheService } from '../cache.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
// import { OpentelemetryService } from '../opentelemetry.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
 _userData: WritableSignal<GetUserProfileResponse | any> = signal(null);
 private destroyRef = inject(DestroyRef);
//  opentelemetryService = inject(OpentelemetryService);
 _getUserProfileDone = signal(false);
 isPlatformBrowser!: boolean;
 dataUser: any;
 logOutTriggered: WritableSignal<boolean> = signal(false);
 _isAuthenticated: WritableSignal<boolean> = signal(false);
 _isLoadingAuth = signal(true);
 userCuid = signal('');

    authRepo = inject(AuthRepository);
    constructor(
        public userProfileRepo: UserProfileRepository,
        @Inject(DOCUMENT) private document: any,
        @Inject(PLATFORM_ID) private platformId: Object,
        private webengageService: WebengageService
    ) {
        this.isPlatformBrowser = isPlatformBrowser(platformId);
        this.userProfile();
    }

 SendActivationCode(model: SendActivationCodeRequest) {
  return this.authRepo.sendActivationCode(model);
 }
 VerifyActivationCode(model: VerifyActivationCodeRequest) {
  return this.authRepo.verifyActivationCode(model);
 }
 forgetPassword(model: ForgetPasswordRequest) {
  return this.authRepo.forgetPassword(model);
 }
 loginUser(model: LoginRequest) {
  return this.authRepo.login(model);
 }
 userProfile() {
  if (this.isPlatformBrowser) {
   let token: any = localStorage.getItem('AccessToken');
   if (token != 'undefined' && token != 'null' && token != null) {
    const decoded: any = jwtDecode(token);
    this._userData.set(decoded);
    this._isAuthenticated.set(true);
    this._isLoadingAuth.set(false);
    this.logOutTriggered.set(false);
    this.userCuid.set(this._userData());
    this.sendUserLoginEvent();
    // this.opentelemetryService.startSpan('login');
    // this.opentelemetryService.sendEvent('login', {
    //  Session_Id: '',
    //  'mobile phone': this._userData()?.mobile,
    //  First_track_id: '',
    // });
   // this.opentelemetryService.endSpan();
   } else {
    localStorage.removeItem('AccessToken');
    this._userData.set(null);
    this._isLoadingAuth.set(false);
    this._isAuthenticated.set(false);
   }
   //  this.userProfileRepo
   //   .getUserProfile()
   //   .pipe(takeUntilDestroyed(this.destroyRef))
   //   .subscribe(
   //    (res) => {
   //     this._getUserProfileDone.set(true);
   //     this._isLoadingAuth.set(false);
   //     if (res) {
   //      this._isAuthenticated.set(true);
   //      if (!this.userCuid()) this.userCuid.set(this.getCookie('cuid'));
   //      this._userData.set(res);
   //      this.sendUserLoginEvent();
   //     }
   //    },
   //    (error: any) => {
   //     this._isLoadingAuth.set(false);
   //     this._userData.set(null);
   //    }
   //   );
  }
 }

    getCookie(name: string) {
        if (this.isPlatformBrowser) {
            const value = `; ${this.document.cookie}`;
            const parts: any = value.split(`; ${name}=`);
            if (parts?.length === 2) return parts.pop().split(';').shift();
        }
    }

    getUserData(): WritableSignal<GetUserProfileResponse> {
        return this._userData;
    }

    logOutUser() {
        if (this.isPlatformBrowser) {
            this.logOutTriggered.set(true);
            this.webengageService.inTrackUserLogout();
            // this.document.cookie = 'UserIsLoggedIn=false;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            this._userData.set(null);
            this._isAuthenticated.set(false);
            this._isLoadingAuth.set(false);
            localStorage.removeItem('AccessToken');
            let logout = this.authRepo.logoutUser();
            return logout;
        } else return;
    }

    sendUserLoginEvent() {
        this.webengageService.intrackLogin(this._userData())
    }


    refreshToken(): Observable<any> {
        // Assuming you store the refresh token in local storage
        const refreshToken = localStorage.getItem('RefreshToken');
        return this.userProfileRepo.refreshToken(refreshToken ? refreshToken : '');
    }
    loginasUser(guid: string): Observable<any> {
      return  this.authRepo.loginAsUser(guid);
    }

}
